var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white shadow overflow-hidden sm:rounded-md" },
    [
      _c(
        "ul",
        _vm._l(_vm.booking.seats, function (seat, index) {
          return _c(
            "li",
            { staticClass: "border-t first:border-t-0 border-gray-200" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.prepareEditSeat(seat)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "px-4 py-4 sm:px-6" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-sm leading-5 font-medium text-primary-600 truncate",
                          },
                          [
                            _vm._v(
                              "\n                            Seat " +
                                _vm._s(index + 1) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ml-2 flex-shrink-0 flex" },
                          [
                            seat.status === 0
                              ? [
                                  _c("badge", { attrs: { color: "gray" } }, [
                                    _vm._v("Unassigned"),
                                  ]),
                                ]
                              : seat.status === 1
                              ? [
                                  _c("badge", { attrs: { color: "blue" } }, [
                                    _vm._v("Invite Sent"),
                                  ]),
                                ]
                              : [_c("badge", [_vm._v("Accepted")])],
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-2 sm:flex sm:justify-between" },
                      [
                        _c("div", { staticClass: "sm:flex" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mr-6 flex items-center text-sm leading-5 text-gray-500",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400",
                                  attrs: {
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                                      "clip-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              seat.status === 0
                                ? [
                                    _vm._v(
                                      "\n                                    Unassigned \n                                    "
                                    ),
                                    index === 0
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "text-primary-600 hover:underline focus:outline-none",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                if (
                                                  $event.target !==
                                                  $event.currentTarget
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.assignToSelf.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Assign to self\n                                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : seat.status === 1
                                ? [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(seat.customer.email) +
                                        "\n                                "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(seat.customer.first_name) +
                                        " " +
                                        _vm._s(seat.customer.last_name) +
                                        "\n                                "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0",
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400",
                                attrs: {
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                Add-ons: "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.addOnsForSeat(seat)),
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _vm.editSeat
            ? _c("modal", {
                on: {
                  hide: function ($event) {
                    _vm.editSeat = null
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("h2", [_vm._v("Edit Seat")]),
                          _vm._v(" "),
                          _vm.editSeat
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "sm:mt-6 sm:grid sm:grid-cols-1 sm:gap-3 sm:grid-flow-row-dense",
                                },
                                [
                                  _c("form-input", {
                                    attrs: {
                                      type: "email",
                                      label: "Email Address",
                                      "read-only":
                                        _vm.editSeat.customer_id !== null,
                                      error: _vm.getErrorFor("email"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.clearErrorFor("email")
                                      },
                                    },
                                    model: {
                                      value: _vm.editSeat.customer.email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editSeat.customer,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "editSeat.customer.email",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.individualAddOns,
                                    function (addOn, index) {
                                      return _c("form-add-on-select", {
                                        key: addOn.id,
                                        attrs: {
                                          label: addOn.name,
                                          options: addOn.selected_options,
                                          "assigned-quantities-on-load":
                                            _vm.addOnAssignedQuantities,
                                          error: _vm.getErrorFor(
                                            `add_ons.${addOn.id}`
                                          ),
                                          disabled: _vm.seatCount === 1,
                                        },
                                        model: {
                                          value:
                                            _vm.editSeat.add_on_values[
                                              addOn.id
                                            ],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editSeat.add_on_values,
                                              addOn.id,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editSeat.add_on_values[addOn.id]",
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense",
                            },
                            [
                              _vm.editSeat &&
                              !_vm.editSeat.member_lock &&
                              _vm.editSeat.status !== 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "flex w-full rounded-md shadow-sm sm:col-span-2",
                                    },
                                    [
                                      _c(
                                        "form-button",
                                        {
                                          staticClass: "w-full",
                                          attrs: { colour: "red" },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.removeFromSeat(
                                                props.hide
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Remove from Seat\n                        "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex w-full rounded-md shadow-sm sm:col-start-2",
                                },
                                [
                                  _c(
                                    "form-button",
                                    {
                                      staticClass: "w-full",
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.updateSeat(props.hide)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Save\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1",
                                },
                                [
                                  _c(
                                    "form-button",
                                    {
                                      staticClass: "w-full",
                                      attrs: { colour: "white" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return props.hide.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Cancel\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3390679028
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getDetails
            ? _c("modal", {
                attrs: { wide: true },
                on: {
                  hide: function ($event) {
                    _vm.getDetails = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            { staticClass: "p-4 sm:p-6" },
                            [
                              _c("h2", { staticClass: "text-2xl mb-2" }, [
                                _vm._v("Your Details"),
                              ]),
                              _vm._v(" "),
                              _c("details-form", {
                                attrs: {
                                  "for-booking-owner": true,
                                  "form-data": _vm.customer,
                                },
                                on: {
                                  "details-updated": function ($event) {
                                    return _vm.updateBookingOwnerSeat(
                                      props.hide
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1806458890
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }